import _ from 'underscore';
import moment from 'moment';

import CoachHubUserModel from 'models/coachhub_user';


export default CoachHubUserModel.extend({
  idAttribute: 'url',
  url: function () {
    return this.get('url');
  },

  latest_message: function () {
    var msg = this.get('latest_message');
    if (msg.category == 'message') {
      return _.escape(msg.body);
    } else if (msg.category == 'reminder') {
      return 'Reminder: ' + m_.escape(msg.body);
    } else if (msg.category == 'appointment-reject') {
      return 'Appt Declined: ' + (msg.body ? _.escape(msg.body) : this.appt_datetime(msg));
    } else if (msg.category == 'appointment-request') {
      return 'Appt Request: ' + this.appt_datetime(msg);
    } else if (msg.category == 'appointment-reminder') {
      return 'Upcoming Appt: ' + this.appt_datetime(msg);
    } else if (msg.category == 'appointment-confirm') {
      return 'Appt Confirmed: ' + this.appt_datetime(msg);
    } else if (msg.category == 'appointment-delete') {
      return 'Appt Cancelled: ' + this.appt_datetime(msg);
    } else if (msg.category == 'permission-grant') {
      return 'Chart Access Granted';
    } else if (msg.category == 'permission-revoke') {
      return 'Chart Access Removed';
    }
  },

  appt_datetime: function (msg) {
    if (!msg.appointment) {
      return '';
    }
    return moment(msg.appointment.start).format('ddd MMM D, h:mm a');
  },

  format_datetime: function () {
    return moment(this.get('latest_message').timestamp).calendar();
  }
});



// WEBPACK FOOTER //
// ./static/js/models/contact.js